import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { colorArray } from '@metro-ui/tokens/js';
import { colorTokenToHex } from '@metro-ui/tokens/utils';
import { responsiveProp, responsivePropTypes, } from '../utils/responsiveProp';
export var SvgIcon = styled(function (_a) {
    var a11yTitle = _a.a11yTitle, _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 32 32' : _b, size = _a.size, color = _a.color, dimensions = _a.dimensions, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["a11yTitle", "viewBox", "size", "color", "dimensions", "className", "children"]);
    var style = __assign(__assign({}, (htmlAttributes && htmlAttributes.style)), (color && { color: colorTokenToHex(color) }));
    return (React.createElement("svg", __assign({}, htmlAttributes, { className: className }, {
        viewBox: viewBox,
        style: style,
        'aria-hidden': a11yTitle ? 'false' : 'true',
        role: a11yTitle ? 'img' : 'presentation',
    }, { focusable: "false" }),
        children,
        !!a11yTitle && React.createElement("title", null, a11yTitle)));
})(function (_a) {
    var dimensions = _a.dimensions, _b = _a.size, size = _b === void 0 ? 1 : _b;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: calc(1.5 * ", "rem);\n    height: calc(1.5 * ", "rem);\n\n    fill: currentColor;\n    stroke-width: 1.5px;\n\n    flex-shrink: 0;\n\n    ", "\n  "], ["\n    width: calc(1.5 * ", "rem);\n    height: calc(1.5 * ", "rem);\n\n    fill: currentColor;\n    stroke-width: 1.5px;\n\n    flex-shrink: 0;\n\n    ", "\n  "])), size, size, responsiveProp(dimensions, undefined, function (val) {
        return val &&
            "width: calc(1.5 * " + val.width + "rem); height: calc(1.5 * " + val.height + "rem);";
    }));
});
export var IconPropTypes = {
    a11yTitle: PropTypes.string,
    viewBox: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.oneOf(colorArray),
    dimensions: responsivePropTypes(PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    })),
    className: PropTypes.string,
};
// @ts-ignore
SvgIcon.propTypes = __assign(__assign({}, IconPropTypes), { children: PropTypes.node.isRequired });
var templateObject_1;
//# sourceMappingURL=SvgIcon.js.map